import React from 'react';

import { Box, Button, Grid } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';

import { ReactHookFormInput } from 'common/components/form/bootstrap';
import ShowErrors from 'common/components/ShowErrors';
import yupResolver from 'common/utils/yupResolver';

import * as selectors from '../selectors';
import validate from '../validate';

const FormContainer = ({
    errors,
    onSubmit,
    initialValues,
    isLoadingSession,
}) => {
    const { t } = useTranslation();

    const { control, handleSubmit } = useForm({
        defaultValues: initialValues,
        resolver: yupResolver(validate),
    });

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <Grid container>
                <Grid size="grow">
                    <ReactHookFormInput
                        autoComplete="off"
                        control={control}
                        id="register_form_text_first_name"
                        name="first_name"
                        placeholder={t('Name', { count: 2 })}
                        type="text"
                    />
                </Grid>

                <Grid size="grow">
                    <ReactHookFormInput
                        autoComplete="off"
                        control={control}
                        name="last_name"
                        placeholder={t('Last name', { count: 2 })}
                        type="text"
                        id="register_form_text_last_name"
                    />
                </Grid>
            </Grid>

            <Grid container>
                <Grid size="grow">
                    <ReactHookFormInput
                        autoComplete="off"
                        control={control}
                        name="email"
                        placeholder={t('Email')}
                        type="email"
                        id="register_form_text_email"
                    />
                </Grid>
            </Grid>

            <Grid container>
                <Grid size="grow">
                    <ReactHookFormInput
                        autoComplete="off"
                        control={control}
                        name="confirm_email"
                        placeholder={t('Confirm your email')}
                        type="email"
                        id="register_form_text_confirm_email"
                    />
                </Grid>
            </Grid>

            <Grid container>
                <Grid size="grow">
                    <ReactHookFormInput
                        autoComplete="off"
                        control={control}
                        name="business_name"
                        placeholder={t('Business name')}
                        type="text"
                        id="register_form_text_business_name"
                    />
                </Grid>
            </Grid>

            <Grid container>
                <Grid size="grow">
                    <ReactHookFormInput
                        autoComplete="off"
                        control={control}
                        name="phone"
                        placeholder={t('Business phone')}
                        type="phone"
                        id="register_form_number_business_phone"
                    />
                </Grid>
            </Grid>

            <ShowErrors errors={errors} />

            <Box sx={{ textAlign: 'center', mt: 2 }}>
                <Button
                    disabled={isLoadingSession}
                    fullWidth
                    id="register_form_create_button"
                    type="submit"
                    size="large"
                >
                    {isLoadingSession
                        ? t('Loading').concat('...')
                        : t('Create account')}
                </Button>
            </Box>
        </form>
    );
};

const mapStateToProps = createStructuredSelector({
    address: selectors.getDataFetchGeocode,
});

FormContainer.propTypes = {
    errors: PropTypes.array,
    onSubmit: PropTypes.func,
    initialValues: PropTypes.object,
    isLoadingSession: PropTypes.bool,
};

export default connect(mapStateToProps)(withRouter(FormContainer));
